const LiveRequest = [
  "Create Document",
  "Document Details",
  "Review and Sign",
  // "FIELDS",
  // "REVIEW",
];

const LiveSignRequestSteps = [
  "Create Document",
  "Document Details",
  "Review and Sign",
  // "FIELDS",
  // "REVIEW",
];

const LiveSendRequestSteps = [
  "Create Document",
  "Document Details",
  "Review and Send",
  // "FIELDS",
  // "REVIEW",
];

export {
  LiveSignRequestSteps,
  LiveSendRequestSteps,
};

export default LiveRequest;
